import {
  Card,
  CardHeader,
  CardTitle,
  CardAction,
  CardDescription,
} from '@/components/ui/card';
import AddNotesDialog from './AddNotesDialog';
import type { Deliverable } from './CreateProjectContext';
import MarkdownDisplay from '@/components/MarkdownDisplay';

interface DetailsDeliverableCardProps {
  deliverable: Deliverable;
  index: number;
  onUpdate: (index: number, updated: Partial<Deliverable>) => void;
}

export default function DetailsDeliverableCard({
  deliverable,
  index,
  onUpdate,
}: DetailsDeliverableCardProps) {
  const handleUpdate = (updated: Partial<Deliverable>) => {
    onUpdate(index, updated);
  };

  return (
    <Card className="bg-muted">
      <CardHeader>
        <CardTitle className="mb-2">{deliverable.deliverableName}</CardTitle>
        <div className="flex gap-10">
          <div>
            <div className="text-sm">Video Type</div>
            <div className="text-muted-foreground">{deliverable.videoType}</div>
          </div>
          <div>
            <div className="text-sm">Length</div>
            <div className="text-muted-foreground">
              {deliverable.lengthRange}
            </div>
          </div>
          <div>
            <div className="text-sm">Format</div>
            <div className="text-muted-foreground">
              {deliverable.aspectRatio}
            </div>
          </div>
          <div>
            <div className="text-sm">Resolution</div>
            <div className="text-muted-foreground">
              {deliverable.resolution}
            </div>
          </div>
          <div>
            <div className="text-sm">Frame Rate</div>
            <div className="text-muted-foreground">{deliverable.frameRate}</div>
          </div>
        </div>
        <CardAction>
          <AddNotesDialog deliverable={deliverable} onUpdate={handleUpdate} />
        </CardAction>
      </CardHeader>
      {deliverable.notes ? (
        <CardDescription className="ml-6 -mt-2 -mb-4">
          <div className="text-sm text-white">Notes</div>
          <div className="mr-2">
            <MarkdownDisplay
              content={deliverable.notes}
              variant='simple'
              expandable={true}
              lines={5}
              size='sm'
              className="text-muted-foreground prose-headings:text-muted-foreground prose-strong:text-muted-foreground prose-a:text-muted-foreground prose-blockquote:text-muted-foreground"
            />

          </div>
        </CardDescription>
      ) : null}
    </Card>
  );
}
